/* import __COLOCATED_TEMPLATE__ from './escalation-search.hbs'; */
/* RESPONSIBLE TEAM: team-ai-agent */
import templateOnly from '@ember/component/template-only';

interface Args {
  searchFunction: (event: Event) => void;
  searchTerm: string | undefined;
  resetSearch: () => void;
}

interface Signature {
  Args: Args;
  Element: HTMLElement;
}

const EscalationSearch = templateOnly<Signature>();

export default EscalationSearch;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'AiAgent::Escalation::EscalationSearch': typeof EscalationSearch;
    'ai-agent/escalation/escalation-search': typeof EscalationSearch;
  }
}
